import { useState, useEffect } from 'react';
import { getESMOverdueStocksFilterOptions } from '@/lib/api/esmOverdueStocksApi';
import { ESMOverdueStocksFilterOptions } from '@/types/esmOverdueStocks';

export function useESMOverdueStocksFilterOptions() {
  const [filterOptions, setFilterOptions] = useState<ESMOverdueStocksFilterOptions | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchFilterOptions = async () => {
      try {
        setLoading(true);
        setError(null);
        const options = await getESMOverdueStocksFilterOptions();
        setFilterOptions(options);
      } catch (err) {
        const errorMessage = err instanceof Error
          ? err.message
          : 'Failed to load filter options. Please try again later.';
        setError(errorMessage);
      } finally {
        setLoading(false);
      }
    };

    fetchFilterOptions();
  }, []);

  return {
    filterOptions,
    loading,
    error,
  };
}
